import * as React from 'react';

export const HandbookTitle = () => {
  return <span></span>;
};
